module.exports = __webpack_public_path__ + "img/nihonmatsuri23.657ba4f3.png";